import "core-js/modules/es6.regexp.replace";
export const TYPES = {
  CATEGORY: 'category',
  PRODUCT: 'product',
  AGGREGATE_OFFER: 'AggregateOffer',
  OFFER: 'offer',
  HOMEPAGE: 'homepage',
  ORGANISATION: 'organisation',
  SEARCH_ACTION: 'search-action'
};
const CONTEXT = 'http://schema.org';
const BRAND = 'Maisons du Monde';
const SCHEMA_TYPES = {
  [TYPES.CATEGORY]: 'Product',
  [TYPES.PRODUCT]: 'Product',
  [TYPES.AGGREGATE_OFFER]: 'AggregateOffer',
  [TYPES.OFFER]: 'Offer',
  [TYPES.HOMEPAGE]: 'WebSite',
  [TYPES.ORGANISATION]: 'Organization',
  [TYPES.SEARCH_ACTION]: 'SearchAction'
};

const getProductDescription = product => {
  if (product.additionalInformation.metaDescription) {
    return product.additionalInformation.metaDescription;
  }

  return product.description.main ? product.description.main.replace(/\n|\r|\t|<(?:.|\n)*?>/gm, '').trim().slice(0, 150) : '';
};

const getProductAvailability = product => {
  if (product.stock.status === 'STORE_ONLY') {
    return 'InStoreOnly';
  }

  if (product.additionalInformation.buyable) {
    return 'InStock';
  }

  return 'OutOfStock';
};

const getProductPrice = (_ref) => {
  let {
    price
  } = _ref;
  return price.sales.amount ? "".concat(price.sales.amount) : "".concat(price.base.amount);
};

const SCHEMAS = {
  [TYPES.CATEGORY](category, _ref2) {
    let {
      currency
    } = _ref2;
    const {
      facets
    } = category.filters.find((_ref3) => {
      let {
        name
      } = _ref3;
      return name === 'price';
    });
    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.CATEGORY],
      name: category.name,
      description: category.seo.meta_description,
      brand: BRAND,
      offers: {
        '@type': SCHEMA_TYPES[TYPES.AGGREGATE_OFFER],
        lowPrice: facets.min.toFixed(2),
        highPrice: facets.max.toFixed(2),
        offerCount: category.total,
        priceCurrency: currency
      },
      url: category.url,
      image: category.image
    };
  },

  [TYPES.PRODUCT](product) {
    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.PRODUCT],
      name: product.name,
      description: getProductDescription(product),
      image: product.images[0].src,
      brand: BRAND,
      offers: {
        '@type': SCHEMA_TYPES[TYPES.OFFER],
        availability: getProductAvailability(product),
        price: getProductPrice(product),
        priceCurrency: product.currency,
        itemCondition: 'new'
      },
      url: product.url
    };
  },

  [TYPES.HOMEPAGE](prismic, locale) {
    return {
      '@context': CONTEXT,
      '@type': SCHEMA_TYPES[TYPES.HOMEPAGE],
      url: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language),
      name: prismic.meta_title,
      image: prismic.thumbnail.url || '',
      publisher: {
        '@type': SCHEMA_TYPES[TYPES.ORGANISATION],
        name: BRAND
      },
      potentialAction: {
        '@type': SCHEMA_TYPES[TYPES.SEARCH_ACTION],
        target: "".concat(prismic.url, "/").concat(locale.market, "/").concat(locale.language, "/q/{search_term_string}"),
        'query-input': 'required name=search_term_string',
        keywords: prismic.keywords.map((_ref4) => {
          let {
            keyword
          } = _ref4;
          return keyword;
        }).filter(keyword => keyword).join(),
        sameAs: prismic.sameAs.map((_ref5) => {
          let {
            url: {
              url
            }
          } = _ref5;
          return url;
        }).filter(url => url)
      }
    };
  }

};

const undefinedSchema = type => () => console.warn("Schema for \"".concat(type, "\" is not defined"));

const getJsonLD = type => SCHEMAS[type] || undefinedSchema(type);

export default getJsonLD;